

import React, { useEffect, useMemo, useState } from "react";
import { useTicketHistory } from "./store";
import { Tooltip } from 'antd';
import { Placeholder } from "react-bootstrap";
import { getFormattedDate, snakeCaseToCapitalizedWords, } from "modules/utilities/utility";
import EditIcon from "assets/img/illustrations/EditIcon";
import NoData from "assets/svgs/no_data/NoData";
import Ticket from "./Ticket";
import TicketModals from "modules/my_tickets/TicketModals";
import UpdateTicket from "modules/my_tickets/UpdateTicket";
import AdvanceTableWrapper from "modules/common/advance-table/AdvanceTableWrapper";
import AdvanceTable from "modules/common/advance-table/AdvanceTable";
import useDoctorDashboardStore from 'modules/all_doctor_dashboard/store';
// import EditAction from 'modules/my_tickets/EditAction';

function TicketHistory({ customer, setMessageFloater }) {
  const { fetchTicketHistory, ticketData, isLoading } = useTicketHistory();
  const [ticketHistory, setTicketHistory] = useState([]);
  const [refresh, setRefresh] = useState(false);
  const [selectedColumnData, setSelectedColumnData] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const { docBookingData, fetchDoctorAppointmentData } = useDoctorDashboardStore();
  const [appointments, setAppointments] = useState([]);


  const handleFirstColumnClick = (data) => {
    setSelectedColumnData(data);
    setShowModal(true);
  };

  useEffect(() => {
    setMessageFloater(false);
    if (customer?.id) { fetchTicketHistory(customer?.id); }
  }, [customer.id, refresh]);

  useEffect(() => {
    if (ticketData?.length) { setTicketHistory(ticketData.reverse()); }
    else { setTicketHistory([]); }
  }, [ticketData]);

  useEffect(() => { 
    if ((ticketData?.[0]?.case_id)){
            fetchDoctorAppointmentData(ticketData?.[0]?.case_id, setAppointments);         
    }
  },[ticketData?.[0]?.case_id]);

  const tableData = useMemo(() => {
    return ticketHistory.map((item) => {
      return {
        ticket_id: item._id,
        status: item.status,
        first_name: item.current_assignment.first_name,
        ticket: item,
      };
    });
  }, [ticketHistory]);

  const columns = [
    {
      accessor: "ticket_id",
      Header: "Id",
      headerProps: { className: "text-900" },
      Cell: (rowData) => {
        const { ticket } = rowData.row.original;
        return (
          <div className="cursor-pointer" onClick={() => handleFirstColumnClick(ticket)}>
            {ticket._id}
          </div>
        );
      },
    },
    {
      accessor: "status",
      Header: "Status",
      headerProps: { className: "text-900" },
    },
    {
      accessor: "",
      Header: "Assignee",
      headerProps: { className: "text-900" },
      Cell: (rowData) => {
        const { ticket } = rowData.row.original;
        return <div>{ticket.current_assignment.first_name}</div>;
      },
    },
    {
      accessor: "",
      Header: "Category",
      headerProps: { className: "text-900" },
      Cell: (rowData) => {
        const { ticket } = rowData.row.original;
        return (
          <div>
            {snakeCaseToCapitalizedWords(ticket.category)}, <br />
            {snakeCaseToCapitalizedWords(ticket.sub_category)}
          </div>
        );
      },
    },
    {
      accessor: "",
      Header: "Created At",
      headerProps: { className: "text-900" },
      Cell: (rowData) => {
        const { ticket } = rowData.row.original;
        return <div>{getFormattedDate(ticket.createdAt)}</div>;
      },
    },
    {
      accessor: "",
      Header: "Doctor Call Attempt",
      headerProps: { className: "text-900" },
      Cell: (rowData) => {
        const { ticket } = rowData.row.original;
        return <div>{ticket.doctor_call_attempt || "N/A"}</div>;
      },
    },
    {
      accessor: "",
      Header: "Doctor Assignment Count",
      headerProps: { className: "text-900" },
      Cell: (rowData) => {
        const { ticket } = rowData.row.original;
        return <div>{ticket.doctor_assignment_count || "N/A"}</div>;
      },
    },
    {
      accessor: "",
      Header: "Actions",
      headerProps: { className: "text-900" },
      Cell: (rowData) => {
        const { ticket } = rowData.row.original;
        return (
          <div className="d-flex gap-2 flex-wrap">
            <UpdateTicket customer={customer} rowData={ticket} refresh={refresh} setRefresh={setRefresh} comment={ticket?.provider_meta?.description} docBookingData={docBookingData} />
            <Ticket id={ticket._id} phoneNo={ticket.customer.phone_number} history={ticket.history} slotTime={ticket.slotTime ?? ""} />
          </div>
        );
      },
    }
  ];

  return (
    <div className="text-black shadow rounded">
      <div
        style={{ height: "27.5rem", overflowY: "scroll" }}
        className="scrollable-section"
      >
        {isLoading ? (
          <div className="d-flex w-100 border border-top-0 text-center align-items-center p-3">
            {Array.from({ length: 6 }).map((_, index) => (
              <span className="flex-1 p-3" key={index}>
                <Placeholder as="p" animation="wave">
                  <Placeholder xs={12} />
                </Placeholder>
              </span>
            ))}
          </div>
        ) : tableData?.length > 0 ? (
          <AdvanceTableWrapper columns={columns} data={tableData}>
            <AdvanceTable
              table
              headerClassName="bg-200 text-nowrap align-middle"
              rowClassName="align-middle white-space-nowrap"
              tableProps={{
                bordered: true,
                striped: true,
                className: "fs-10 mb-0 overflow-hidden",
              }}
            />
          </AdvanceTableWrapper>
        ) : (
          <div className="p-3 fs-1 d-flex align-items-center justify-content-center fw-bold rounded-bottom">
            No Data Available
            <span className="mx-2">
              <NoData />
            </span>
          </div>
        )}
      </div>
      <TicketModals
        showModal={showModal}
        setShowModal={setShowModal}
        selectedColumnData={selectedColumnData}
      />
    </div>
  );
}

export default TicketHistory;
